/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Board_Default_CautionInputs */

const en_delivery_board_default_caution = /** @type {(inputs: Delivery_Board_Default_CautionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buyer is more than 5km away`)
};

const es_delivery_board_default_caution = /** @type {(inputs: Delivery_Board_Default_CautionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El comprador está a más de 5km`)
};

const fr_delivery_board_default_caution = /** @type {(inputs: Delivery_Board_Default_CautionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'acheteur est à plus de 5 km`)
};

const de_delivery_board_default_caution = /** @type {(inputs: Delivery_Board_Default_CautionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Käufer ist mehr als 5 km entfernt`)
};

const id_delivery_board_default_caution = /** @type {(inputs: Delivery_Board_Default_CautionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembeli berjarak lebih dari 5km`)
};

/** @type {(inputs: Delivery_Board_Default_CautionInputs) => LocalizedString} */
const ja_delivery_board_default_caution = en_delivery_board_default_caution;

/** @type {(inputs: Delivery_Board_Default_CautionInputs) => LocalizedString} */
const zh_delivery_board_default_caution = en_delivery_board_default_caution;

/** @type {(inputs: Delivery_Board_Default_CautionInputs) => LocalizedString} */
const ar_delivery_board_default_caution = en_delivery_board_default_caution;

/** @type {(inputs: Delivery_Board_Default_CautionInputs) => LocalizedString} */
const it_delivery_board_default_caution = en_delivery_board_default_caution;

/** @type {(inputs: Delivery_Board_Default_CautionInputs) => LocalizedString} */
const ru_delivery_board_default_caution = en_delivery_board_default_caution;

/** @type {(inputs: Delivery_Board_Default_CautionInputs) => LocalizedString} */
const pt_delivery_board_default_caution = en_delivery_board_default_caution;

/** @type {(inputs: Delivery_Board_Default_CautionInputs) => LocalizedString} */
const ko_delivery_board_default_caution = en_delivery_board_default_caution;

/**
* | output |
* | --- |
* | "Buyer is more than 5km away" |
*
* @param {Delivery_Board_Default_CautionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_board_default_caution = /** @type {((inputs?: Delivery_Board_Default_CautionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Board_Default_CautionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_board_default_caution(inputs)
	if (locale === "es") return es_delivery_board_default_caution(inputs)
	if (locale === "fr") return fr_delivery_board_default_caution(inputs)
	if (locale === "de") return de_delivery_board_default_caution(inputs)
	if (locale === "ja") return ja_delivery_board_default_caution(inputs)
	if (locale === "zh") return zh_delivery_board_default_caution(inputs)
	if (locale === "ar") return ar_delivery_board_default_caution(inputs)
	if (locale === "id") return id_delivery_board_default_caution(inputs)
	if (locale === "it") return it_delivery_board_default_caution(inputs)
	if (locale === "ru") return ru_delivery_board_default_caution(inputs)
	if (locale === "pt") return pt_delivery_board_default_caution(inputs)
	return ko_delivery_board_default_caution(inputs)
});